import { createContext, type Dispatch, type SetStateAction } from "react";
import { UrlUpdateType } from "use-query-params";
import {
    InvoiceByCounterpartySortValue,
    InvoicesByCounterpartyItem,
} from "@common/types/invoice";
import { SortByCounterparty } from "./useSortByCounterparty";

export interface InvoicesByCounterpartyTableContextValue {
    currentPage: number;
    totalPages: number;
    counterpartiesCount: number;
    setPage:
        | Dispatch<SetStateAction<number>>
        | ((
              newValue: number | null | undefined,
              updateType?: UrlUpdateType,
          ) => void);
    handleSortChange: SortByCounterparty["handleSortChange"];
    currentSort: SortByCounterparty["currentSort"];
    isLoading: boolean;
    data?: InvoicesByCounterpartyItem[];
}

const defaultValue: InvoicesByCounterpartyTableContextValue = {
    currentPage: 0,
    totalPages: 0,
    counterpartiesCount: 0,
    setPage: () => {},
    handleSortChange: () => {},
    currentSort: InvoiceByCounterpartySortValue.INVOICES_COUNT_DESC,
    isLoading: false,
};

export const InvoicesByCounterpartyTableContext =
    createContext<InvoicesByCounterpartyTableContextValue>(defaultValue);
